import { Link } from "react-router-dom";
import SectionHeader from "./SectionHeader";

const FEATURES = [
  {
    eyebrow: "甜瓜专栏",
    accent: true,
    title: "把喜欢说出口的那一瞬间",
    desc: "有人为一句告白排练了三个月，有人用一整个学期的笔记换一句我愿意。恋爱与表白专栏记录校园里那些小心翼翼又拼尽全力的心动。",
    bullets: ["图书馆隔座相识的慢慢靠近", "操场与烟火下的公开告白", "异地里被好好珍惜的想念"],
    link: "/column/biaobai",
    cta: "去看表白现场",
    image:
      "https://readdy.ai/api/search-image?query=close%20up%20of%20a%20student%20holding%20a%20bouquet%20of%20flowers%20with%20a%20shy%20smile%20against%20soft%20warm%20cream%20background%2C%20coral%20and%20blush%20tones%2C%20dreamy%20portrait%20photography&width=900&height=720&seq=band-love&orientation=portrait",
  },
  {
    eyebrow: "复盘专栏",
    accent: false,
    title: "那些戛然而止的感情，后来都怎样了",
    desc: "一条没回的消息、六百公里的距离、朋友圈里悄悄消失的合照。分手与纠纷专栏不制造焦虑，只陪你把没说完的话听完。",
    bullets: ["冷战背后没出口的委屈", "毕业分岔路的两难选择", "从争吵里学会的相处分寸"],
    link: "/column/fenshou",
    cta: "进入分手复盘",
    image:
      "https://readdy.ai/api/search-image?query=student%20looking%20out%20a%20window%20at%20rain%20with%20a%20cup%20of%20tea%2C%20muted%20sage%20green%20and%20amber%20tones%2C%20contemplative%20moody%20cinematic%20portrait%20photography&width=900&height=720&seq=band-break&orientation=portrait",
  },
];

export default function FeaturedBands() {
  return (
    <section className="mx-auto max-w-7xl px-4 py-4 md:px-6 md:py-6">
      <div className="py-4 md:py-6">
        <SectionHeader eyebrow="编辑精选" title="专题瓜田 · 值得细看" desc="编辑团队从不同角度切入，把散落的校园故事串成值得一口气读完的专题。" />
      </div>
      <div className="mt-6 space-y-8 md:space-y-12">
        {FEATURES.map((f, i) => (
          <article
            key={f.eyebrow}
            className={`grid items-center gap-0 overflow-hidden rounded-2xl border border-background-200/70 md:grid-cols-2 ${
              i % 2 === 1 ? "md:[direction:rtl]" : ""
            } ${f.accent ? "bg-accent-100/70" : "bg-secondary-100/70"}`}
          >
            <div className="relative h-56 w-full overflow-hidden md:h-[420px] md:[direction:ltr]">
              <img src={f.image} alt={f.title} className="h-full w-full object-cover object-top" />
            </div>
            <div className="p-6 md:p-10 md:[direction:ltr]">
              <span
                className={`inline-flex items-center gap-1.5 rounded-full px-3 py-1 text-xs font-medium ${
                  f.accent ? "bg-accent-500 text-background-50" : "bg-secondary-500 text-background-50"
                }`}
              >
                <i className="ri-bookmark-line" aria-hidden="true" />
                {f.eyebrow}
              </span>
              <h3 className="mt-4 font-heading text-xl font-black leading-snug text-foreground-950 md:text-2xl">{f.title}</h3>
              <p className="mt-3 text-sm leading-7 text-foreground-700 md:text-base">{f.desc}</p>
              <ul className="mt-5 space-y-2.5">
                {f.bullets.map((b) => (
                  <li key={b} className="flex items-center gap-2 text-sm text-foreground-700">
                    <i className={`${f.accent ? "text-accent-600" : "text-secondary-700"} ri-check-double-line`} aria-hidden="true" />
                    {b}
                  </li>
                ))}
              </ul>
              <Link
                to={f.link}
                className="mt-6 inline-flex items-center gap-2 whitespace-nowrap rounded-full bg-foreground-950 px-5 py-2.5 text-sm font-medium text-background-50 transition-colors hover:bg-foreground-800"
              >
                {f.cta}
                <i className="ri-arrow-right-line" aria-hidden="true" />
              </Link>
            </div>
          </article>
        ))}
      </div>
    </section>
  );
}